import { Result, Paginate, ResultWithPaginate } from '@/types/Global';

import request from './request';
import { WorkStatusEnum } from '../types/enum/user';

export interface MulerunAuthReq {
  userId: string;
  sessionId: string;
  agentId: string;
  time: string;
  origin: string;
  nonce: string;
  signature: string;
}

export interface MulerunAuthResp {
  token: string;
  expire_at: number;
}

export interface ChangeWorkStatusReq {
  status: WorkStatusEnum;
}

export const loginByMulerunAuth = (data: MulerunAuthReq) =>
  request.post<MulerunAuthReq, Result<MulerunAuthResp>>(
    '/api/iframe/mulerun-auth',
    data,
  );

/** 启动/暂停 */
export const changeWorkStatus = (data: ChangeWorkStatusReq) =>
  request.post<ChangeWorkStatusReq, Result<null>>(
    '/api/iframe/work-status',
    data,
  );

export const getWorkStatus = () =>
  request.post<null, Result<{ status: WorkStatusEnum }>>(
    '/api/iframe/get-status',
  );
